import { JDSRadioButtonProps } from './generated';
import { MODIFIED_PROPS } from '../../generators/modifyProps';
import { useSwitch } from '../../hooks/switch';

export interface InputRadioProps extends Omit<JDSRadioButtonProps, 'onClick'> {
  stateConfig?: {
    errorText?: string;
    successText?: string;
    warningText?: string;
    requiredText?: string;
  };
  /**
   * @deprecated. IDs are not supported now on JDS Components
   */
  id?: string;
  onChange?: (ev: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: (ev: React.MouseEvent<HTMLInputElement>) => void;
  value?: string;
  /**
   * @deprecated this prop is not supported now
   */
  name?: string;
  ariaLabel?: string;
  ariaDescribedby?: string;
}

export const PROP_MAP = (
  props: InputRadioProps
): MODIFIED_PROPS<InputRadioProps> => {
  return {
    state: {
      properties: {
        state: props.state
      },
      variations: {
        error: {
          stateText: props.stateConfig?.errorText
        },
        success: {
          stateText: props.stateConfig?.successText
        },
        warning: {
          stateText: props.stateConfig?.warningText
        },
        required: {
          stateText: props.stateConfig?.requiredText
        }
      }
    },
    label: {
      properties: {
        labelText: props.label
      }
    },
    id: {
      properties: {
        labelText: props.id
      }
    }
  };
};

export const withLogic =
  (
    Component: React.ComponentType<InputRadioProps>
  ): React.FC<InputRadioProps> =>
  (props: InputRadioProps) => {
    const { switchState, onChange } = useSwitch(props.checked);
    return (
      <Component
        {...{
          ...props,
          checked: switchState,
          onClick: (ev: React.MouseEvent<HTMLInputElement>) => {
            const target = {
              ...ev.target,
              value: props.value || '',
              checked: !switchState
            };
            const event = {
              ...ev,
              target
            };
            if (!switchState || props.checked !== switchState) {
              onChange?.(!switchState);
              props.onChange?.(event as any);
            }
            props.onClick?.(event as React.MouseEvent<HTMLInputElement>);
          }
        }}
      />
    );
  };
